import React from 'react'
import BaseComponent from './BaseContainer'
import { graphql, compose, withApollo } from 'react-apollo'
import { Redirect } from 'react-router'
import GuideForm from '../components/form/Guide'
import getGuide from '../apollo/graphql/guide/get'
import getGuides from '../apollo/graphql/guide/getGuides'
import getPlaces from '../apollo/graphql/getPlaces'
import getCourses from '../apollo/graphql/course/getCourses'
import createGuide from '../apollo/graphql/guide/create'
import deleteGuide from '../apollo/graphql/guide/delete'
import updateGuide from '../apollo/graphql/guide/update'
import { convertGraphQlToObject, convertObjetToGraphQlVariables } from '../helpers/contentWithI18n'
import { languages } from '../constants'
import { createTranslationsObject } from '../helpers/translation'

class GuideContainer extends BaseComponent {

  constructor(props) {
    super(props)

    const isNew = props.match.params.objId === 'new' || props.match.params.objId === undefined

    this.state = {
      status: {
        loading: true,
        message: null,
        error: null,
        isNew: isNew,
        deletion: { confirm: false }
      },
      redirect: false,
      obj: {
        type: '',
        status: '',
        img_header_desktop: '',
        img_header_mobile: '',
        img_medallion: '',
        file_audio_guide: '',
        duration: '',
        place: '',
        order: 0,
        guide_id: null,
        course_id: null,
        translations: createTranslationsObject({
          title: '',
          content: '',
          instruction: '',
          medallion_title: '',
          instruction_title: '',
          push_label: '',
          century_1: '',
          century_2: '',
          file_audio_guide: ''
        })
      },
    }
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
  }

  componentDidMount() {
    if (!this.state.status.isNew) {
      this.props.client.query({
        query: getGuide,
        variables: { id: this.props.match.params.objId },
      }).then(({ data }) => {
        if (getGuide.error) {
          this.setState({
            status: {
              ...this.state.status,
              error: true, message: getGuide.error.message
            }
          })
        }

        const newObject = {...this.state.obj, ...convertGraphQlToObject(data.getGuide)}
        this.setState({
          ...this.state,
          status: {
            ...this.state.status,
            loading: false
          },
          obj: {
            ...this.state.obj,
            ...newObject,
            translations: {
              ...this.state.obj.translations,
              ...newObject.translations
            }
          }
        })
      })
    } else {
      this.setState({
        ...this.state,
        status: {
          ...this.state.status,
          loading: false
        }
      })
    }
  }

  handleChange(event, data, type) {
    let newState = {
      obj: {
        ...this.state.obj
      }
    }

    let dataIsLanguage = false
    for (let att of languages) {
      if (att.code === data) {
        dataIsLanguage = true
        break
      }
    }

    if (event.target.id === 'court' || event.target.id === 'medallion') {
      //guide types
      newState.obj['type'] = event.target.id
    } else if (event.target.id === 'advised' || event.target.id === 'available_soon' || event.target.id === 'available') {
      //guide status
      newState.obj['status'] = event.target.id
    } else if (dataIsLanguage) {
      if (event.target.files && event.target.files.length > 0) {
        //files
        newState.obj.translations[data][event.target.id] = event.target.files[0]
      } else {
        //translations data
        newState.obj.translations[data][event.target.id] = event.target.value
      }
    } else if (type === 'dropdown') {
      //dropdown (place)
      newState.obj[data.id] = data.value
    } else if (event.target.files && event.target.files.length > 0) {
      //files
      newState.obj[event.target.id] = event.target.files[0]
    }  else {
      //simple data
      newState.obj[event.target.id] = event.target.value
    }
    this.setState(newState)
  }

  handleSubmit(event) {
    event.preventDefault()
    window.scrollTo(0, 0)
    this.setState({
      status: {
        ...this.state.status,
        loading: true
      }
    })
    let obj = convertObjetToGraphQlVariables(this.state.obj)
    const objId = obj.id
    delete obj.id
    delete obj.course
    // if (obj.guide_id === null || obj.guide_id === '') {
    //   delete obj.guide_id
    // }
    // if (obj.course_id === null || obj.course_id === '') {
    //   delete obj.course_id
    // }
    if (obj.place === null || obj.place === '') {
      delete obj.place
    }
    this.state.status.isNew ?
      this.props.createGuide({
        variables: {
          input: {...obj}
        }
      }).then(({data, errors}) => {
        if (errors) {
          this.setState({
            status: {
              ...this.state.status,
              loading: false,
              errors: errors
            }
          })
        } else {
          this.setState({ redirect: true })
        }
      }) :
      this.props.updateGuide({
        variables: {
          id: objId,
          input: {...obj}
        }
      }).then(({data, errors}) => {
        if (errors) {
          this.setState({
            status: {
              ...this.state.status,
              loading: false,
              errors: errors
            }
          })
        } else {
          this.setState({ redirect: true })
        }
      })
  }

  handleDelete(event, data) {
    event.preventDefault()
    let newState = {
      status: {
        ...this.state.status,
        deletion: {}
      }
    }
    switch (data.confirm) {
    case true:
      newState.status.deletion.confirm = true
      break
    case null:
      newState.status.deletion.confirm = false
      break
    case false:
      newState.status.deletion.confirm = false
      this.props.deleteGuide({variables: {id: this.state.obj.id}}).then(
        this.props.history.push('/guides')
      ).catch((error) => {
        this.setState({
          status: {
            ...this.state.status,
            loading: false,
            message: error.message,
            error: true
          }
        })
      })
      break
    default:
      break
    }
    this.setState(newState)
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to='/guides'/>
    }
    if (this.state.status.loading) {
      return <div>Chargement</div>
    }

    return <GuideForm
      obj={this.state.obj}
      status={this.state.status}
      places={this.props.places}
      guides={this.props.guides}
      courses={this.props.courses}
      onChange={this.handleChange}
      onSubmit={this.handleSubmit}
      onDelete={this.handleDelete} />
  }
}

const GuideContainerEnhanced = compose(
  graphql(getPlaces, { name: 'places' }),
  graphql(getGuides, { name: 'guides' }),
  graphql(getCourses, { name: 'courses' }),
  graphql(updateGuide, { name: 'updateGuide' }),
  graphql(createGuide, { name: 'createGuide' }),
  graphql(deleteGuide, {
    name: 'deleteGuide',
    options: {
      update: (proxy, { data }) => {
        const guides = proxy.readQuery({ query: getGuides })
        guides.getGuides = guides.getGuides.filter(obj => obj.id !== data.deleteGuide.id)
        proxy.writeQuery({ query: getGuides, data: guides })
      }
    }
  })
)(GuideContainer)

export default withApollo(GuideContainerEnhanced)



// WEBPACK FOOTER //
// ./src/containers/GuideContainer.js